import React, { useState } from "react";
import { Modal, Button } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import { FaWhatsapp } from "react-icons/fa";
import {
  getPersonFullPhoneNumber,
  formatForWhatsApp,
} from "../../../utils/phoneHelpers";

const SupportManagerModal = ({ supportExecutive, supportManager }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleWhatsApp = (person) => {
    const fullPhoneNumber = getPersonFullPhoneNumber(person);
    if (fullPhoneNumber) {
      const cleanPhone = formatForWhatsApp(
        person.phoneCode,
        person.phoneNumber,
      );
      window.open(`https://wa.me/${cleanPhone}`, "_blank");
    }
  };

  const PersonCard = ({ person }) => (
    <div className="mb-6 last:mb-0">
      <div className="flex justify-between items-center">
        <span className="font-medium text-gray-900">
          {person.firstName} {person.lastName}
        </span>
      </div>
      {(person.phoneNumber || person.phoneCode) && (
        <div className="flex gap-3 mt-3">
          <Button
            type="link"
            size="small"
            icon={<PhoneOutlined />}
            href={`tel:${getPersonFullPhoneNumber(person)}`}
            className="p-0 h-auto"
            style={{ color: "#1B75F0", borderRadius: "6px" }}
          >
            Call
          </Button>
          <Button
            type="primary"
            size="small"
            icon={<FaWhatsapp />}
            onClick={() => handleWhatsApp(person)}
            style={{
              backgroundColor: "#25D366",
              borderColor: "#25D366",
              borderRadius: "6px",
            }}
          >
            WhatsApp
          </Button>
        </div>
      )}
    </div>
  );

  const renderPeople = (data) => {
    if (!data) return null;
    const list = Array.isArray(data) ? data : [data];
    return list.map((person, index) => (
      <PersonCard key={person.id || index} person={person} />
    ));
  };

  return (
    <>
      <button
        onClick={() => setIsModalVisible(true)}
        className="inline-flex items-center gap-2 bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-lg px-3 py-2 cursor-pointer hover:shadow-sm transition-shadow"
      >
        <span className="font-medium text-2xl text-gray-700">
          Support Team ℹ️
        </span>
      </button>
      <Modal
        title="Your Support Team"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
        width={500}
      >
        <div>
          {renderPeople(supportExecutive)}
          {renderPeople(supportManager)}
        </div>
      </Modal>
    </>
  );
};

export default SupportManagerModal;
